<template>
  <div class="search_page">
    <!-- 背景光球 -->
    <div class="bg_orb orb_4"></div>
    <div class="bg_orb orb_5"></div>
    <!-- 网格纹理 -->
    <div class="grid_pattern"></div>

    <!-- 顶部横幅区域 -->
    <div class="hero_section">
      <div class="hero_content">
        <h1 class="hero_title">
          <span class="title_highlight">发现</span>精彩直播
        </h1>
        <p class="hero_subtitle">探索万千主播，找到属于你的精彩世界</p>
      </div>
    </div>

    <!-- 搜索头部 - 居中 -->
    <div class="search_header">
      <div class="search_input_wrap">
        <input
          v-model="searchKeyword"
          type="text"
          placeholder="搜索主播"
          class="search_input"
          @keyup.enter="handleSearch"
        />
        <i v-if="searchKeyword" class="el-icon-close clear_icon" @click="clearSearch"></i>
        <span class="search_btn" @click="handleSearch">
          <i class="el-icon-search"></i>
          搜索
        </span>
      </div>
    </div>

    <!-- 搜索内容区域 -->
    <div class="search_content">
      <!-- 未搜索时显示装饰内容 -->
      <template v-if="!hasSearched">
        <div class="default_content">
          <!-- 欢迎区域 -->
          <div class="welcome_section">
            <p class="welcome_desc">搜索你感兴趣的主播，开启互动之旅</p>
          </div>

          <!-- 热门搜索 -->
          <div class="hot_search_section">
            <div class="section_header">
              
              <h3 class="section_title"><i class="el-icon-s-data"></i>热门搜索</h3>
            </div>
            <div class="hot_tags">
              <span
                v-for="(item, index) in hotList"
                :key="index"
                class="hot_tag"
                :class="{ hot_top: index < 3 }"
                @click="quickSearch(item)"
              >
                <span class="hot_num">{{ index + 1 }}</span>
                {{ item }}
              </span>
            </div>
          </div>

          <!-- 搜索历史居中 -->
          <div v-if="searchHistory.length > 0" class="history_section">
            <div class="section_header">
             
              <h3 class="section_title"> <i class="el-icon-time"></i>搜索历史</h3>
              <span class="clear_history" @click="clearHistory">清空</span>
            </div>
            <div class="history_list">
              <span
                v-for="(item, index) in searchHistory"
                :key="index"
                class="history_tag"
                @click="quickSearch(item)"
              >
                {{ item }}
              </span>
            </div>
          </div>


        </div>
      </template>

      <!-- 搜索结果 -->
      <div v-else class="search_result">
        <!-- 加载状态 -->
        <div v-if="loading" class="loading_state">
          <i class="el-icon-loading"></i>
          <span>搜索中...</span>
        </div>

        <!-- 搜索结果内容 -->
        <div v-else-if="searchResults.length > 0" class="result_content">
          <!-- 左侧：搜索结果 -->
          <div class="result_left">
            <!-- 结果统计 -->
            <div class="result_stats">
              找到 <span class="highlight">"{{ searchKeyword }}"</span>，共 <span class="highlight count">{{ searchResults.length }}</span> 个主播
            </div>

            <!-- 精选主播（第一个结果） -->
            <div v-if="searchResults[0]" class="featured_anchor">
              <h3 class="block_title">精选主播</h3>
              <div class="featured_card" @click="enterLiveRoom(searchResults[0].id, searchResults[0].anchorid)">
                <img :src="searchResults[0].touxiang" class="featured_avatar" />
                <div class="featured_info">
                  <span class="featured_name">{{ searchResults[0].anchor_name }}</span>
                  <div class="featured_meta">
                    <span v-if="searchResults[0].statuss == 1" class="live_status">
                      <span class="live_dot"></span>直播中
                    </span>
                    <span class="meta_item">粉丝数: {{ searchResults[0].hot || 0 }}</span>
                    <span class="meta_item">房间号: {{ searchResults[0].id }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 相关主播列表 -->
            <div class="anchor_list_section">
              <div class="block_header">
                <h3 class="block_title">相关主播</h3>
              </div>
              <div class="anchor_list">
                <div
                  v-for="item in searchResults.slice(1)"
                  :key="item.id"
                  class="anchor_item"
                  @click="enterLiveRoom(item.id, item.pos)"
                >
                  <div class="item_avatar_wrap">
                    <img :src="item.touxiang" class="item_avatar" />
                    <span v-if="item.statuss == 1" class="item_live_tag">直播中</span>
                  </div>
                  <span class="item_name">{{ item.anchor_name }}</span>
                  <span class="item_fans">粉丝数: {{ item.hot || 0 }}</span>
                </div>
              </div>
            </div>
          </div>


        </div>

        <!-- 空状态 -->
        <div v-else class="empty_state">
          <div class="empty_icon_wrap">
            <i class="el-icon-search"></i>
          </div>
          <p class="empty_text">未找到 "{{ searchKeyword }}" 相关的主播</p>
          <p class="empty_tip">换个关键词试试吧</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SearchPage',
  data() {
    return {
      // 搜索关键词
      searchKeyword: '',
      // 是否已搜索
      hasSearched: false,
      // 加载状态
      loading: false,
      // 当前Tab
      activeTab: 'anchor',
      // 搜索结果列表
      searchResults: [],
      // 搜索历史（从本地存储读取）
      searchHistory: [],
      // 热门搜索榜单
      hotList: ['中华鼓娘',  '土豆泥大王', '洛洛', '茉莉','四哥','小鱼儿','娇宝','zoey']
    }
  },
  mounted() {
    // 从本地存储加载搜索历史
    this.loadSearchHistory()
  },
  methods: {
    // 从本地存储加载搜索历史
    loadSearchHistory() {
      const history = localStorage.getItem('searchHistory')
      if (history) {
        this.searchHistory = JSON.parse(history)
      }
    },
    // 保存搜索历史到本地存储
    saveSearchHistory() {
      localStorage.setItem('searchHistory', JSON.stringify(this.searchHistory))
    },
    // 执行搜索
    handleSearch() {
      const keyword = this.searchKeyword.trim()
      if (!keyword) {
        this.$message.warning('请输入搜索关键词')
        return
      }
      // 添加到搜索历史
      this.addToHistory(keyword)
      // 设置已搜索状态
      this.hasSearched = true
      this.loading = true
      // 调用搜索接口
      axios.get('https://ttxq.xiangyouhulian.cn/api/index/search', {
        params: {
          title: keyword
        }
      }).then(response => {
        this.loading = false
        if (response.data.code === 1) {
          this.searchResults = response.data.data || []
        } else {
          this.searchResults = []
          this.$message.error(response.data.msg || '搜索失败')
        }
      }).catch(error => {
        this.loading = false
        this.searchResults = []
        console.error('搜索请求失败:', error)
        this.$message.error('网络错误，请稍后重试')
      })
    },
    // 添加到搜索历史
    addToHistory(keyword) {
      // 移除重复项
      const index = this.searchHistory.indexOf(keyword)
      if (index > -1) {
        this.searchHistory.splice(index, 1)
      }
      // 添加到开头
      this.searchHistory.unshift(keyword)
      // 最多保留10条
      if (this.searchHistory.length > 10) {
        this.searchHistory = this.searchHistory.slice(0, 10)
      }
      this.saveSearchHistory()
    },
    // 快速搜索（点击历史或热门标签）
    quickSearch(keyword) {
      this.searchKeyword = keyword
      this.handleSearch()
    },
    // 清空搜索
    clearSearch() {
      this.searchKeyword = ''
      this.hasSearched = false
      this.searchResults = []
    },
    // 清空搜索历史
    clearHistory() {
      this.searchHistory = []
      localStorage.removeItem('searchHistory')
    },
    // 返回上一页
    goBack() {
      this.$router.back()
    },
    // 进入直播间
    enterLiveRoom(id, anchorid) {
      this.$router.push(`/zb/${anchorid}/${id}`)
    }
  }
}
</script>

<style scoped lang="scss">
// 搜索页面容器
.search_page {
  background: linear-gradient(135deg, #1a0a2e 0%, #2d1b4e 50%, #1a0a2e 100%);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;

  // 页面级背景光球
  &::before {
    content: '';
    position: absolute;
    width: 600px;
    height: 600px;
    background: linear-gradient(135deg, #8A3FFC 0%, #A855F7 100%);
    border-radius: 50%;
    filter: blur(120px);
    opacity: 0.4;
    top: -200px;
    right: -100px;
    animation: float 10s ease-in-out infinite;
  }

  &::after {
    content: '';
    position: absolute;
    width: 500px;
    height: 500px;
    background: linear-gradient(135deg, #FF6B6B 0%, #FF8E8E 100%);
    border-radius: 50%;
    filter: blur(100px);
    opacity: 0.3;
    bottom: -150px;
    left: -100px;
    animation: float 12s ease-in-out infinite reverse;
  }
}

// 网格纹理
.grid_pattern {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image:
    linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px);
  background-size: 60px 60px;
  pointer-events: none;
  z-index: 0;
}

// 额外的背景光球
.bg_orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  opacity: 0.25;
  pointer-events: none;

  &.orb_4 {
    width: 400px;
    height: 400px;
    background: linear-gradient(135deg, #10B981 0%, #34D399 100%);
    top: 40%;
    right: 10%;
    animation: float 8s ease-in-out infinite;
    animation-delay: -4s;
  }

  &.orb_5 {
    width: 350px;
    height: 350px;
    background: linear-gradient(135deg, #8A3FFC 0%, #FF6B6B 100%);
    bottom: 20%;
    right: 30%;
    animation: float 9s ease-in-out infinite;
    animation-delay: -2s;
  }
}

// 顶部横幅区域
.hero_section {
  position: relative;
  padding: 100px 40px 80px;
  overflow: hidden;
  background: transparent;
}

.hero_bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0) scale(1);
  }
  50% {
    transform: translateY(-20px) scale(1.05);
  }
}

// 横幅内容
.hero_content {
  position: relative;
  z-index: 1;
  text-align: center;
}

.hero_title {
  font-size: 42px;
  font-weight: 700;
  color: #FFFFFF;
  margin-bottom: 12px;
  letter-spacing: 2px;

  .title_highlight {
    background: linear-gradient(135deg, #8A3FFC 0%, #FF6B6B 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
}

.hero_subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  letter-spacing: 1px;
}

// 搜索头部 - 居中
.search_header {
  display: flex;
  justify-content: center;
  margin-top: -30px;
  margin-bottom: 40px;
  padding: 0 40px;
  position: relative;
  z-index: 10;
}

// 搜索输入框容器
.search_input_wrap {
  display: flex;
  align-items: center;
  width: 640px;
  max-width: 100%;
  background-color: #FFFFFF;
  border: 3px solid #8A3FFC;
  border-radius: 32px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(138, 63, 252, 0.25), 0 0 0 6px rgba(138, 63, 252, 0.1);
  transition: all 0.3s ease;

  &:focus-within {
    box-shadow: 0 12px 40px rgba(138, 63, 252, 0.35), 0 0 0 8px rgba(138, 63, 252, 0.15);
    transform: translateY(-2px);
  }
}

// 搜索输入框
.search_input {
  flex: 1;
  padding: 18px 24px;
  font-size: 16px;
  color: #181426;
  background: transparent;
  border: none;
  outline: none;

  &::placeholder {
    color: #9B8DC7;
  }
}

// 清空图标
.clear_icon {
  font-size: 16px;
  color: #9B8DC7;
  cursor: pointer;
  padding: 8px;
  margin-right: 4px;
  border-radius: 50%;
  transition: all 0.3s ease;

  &:hover {
    color: #8A3FFC;
    background-color: #F9F7FF;
  }
}

// 搜索按钮
.search_btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 18px 32px;
  font-size: 16px;
  font-weight: 600;
  color: #FFFFFF;
  background: linear-gradient(135deg, #8A3FFC 0%, #A855F7 100%);
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #7B2FF2 0%, #9946E6 100%);
  }

  i {
    font-size: 18px;
  }
}

// Tab 导航
.tab_nav {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-bottom: 24px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ECE6FF;
}

// Tab 项
.tab_item {
  font-size: 15px;
  color: #666;
  cursor: pointer;
  padding: 8px 4px;
  position: relative;
  transition: color 0.3s ease;

  &:hover {
    color: #8A3FFC;
  }

  &.active {
    color: #8A3FFC;
    font-weight: 500;

    &::after {
      content: '';
      position: absolute;
      bottom: -13px;
      left: 0;
      right: 0;
      height: 3px;
      background: linear-gradient(135deg, #8A3FFC 0%, #A855F7 100%);
      border-radius: 2px;
    }
  }
}

// 搜索内容区域
.search_content {
  max-width: 1200px;
  margin: 0 auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 40px 60px;
}

// 默认内容布局（未搜索时）
.default_content {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding: 20px 0;
}

// 欢迎区域文字颜色适配深色背景
.welcome_section {
  .welcome_title {
    color: #FFFFFF;
  }
  .welcome_desc {
    color: rgba(255, 255, 255, 0.7);
  }
}

// 区块标题颜色适配深色背景
.section_title {
  color: #FFFFFF;
}

// 清空历史按钮颜色
.clear_history {
  color: rgba(255, 255, 255, 0.7);

  &:hover {
    color: #8A3FFC;
  }
}

// 装饰背景
.decoration_bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
}



// 欢迎区域
.welcome_section {
  text-align: center;
  margin-bottom: 48px;
  z-index: 1;
}

.welcome_icon {
  width: 72px;
  height: 72px;
  margin: 0 auto 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(236, 230, 255, 0.9) 0%, rgba(249, 247, 255, 0.9) 100%);
  border-radius: 20px;
  color: #8A3FFC;
  box-shadow: 0 4px 16px rgba(138, 63, 252, 0.15);
}

.welcome_title {
  font-size: 22px;
  font-weight: 600;
  color: #FFFFFF;
  margin-bottom: 8px;
}

.welcome_desc {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
}

// 热门搜索区域
.hot_search_section {
  width: 640px;
  max-width: 100%;
  margin-bottom: 40px;
  z-index: 1;

  .section_header {
    color: #fff;
  }
}

.hot_tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.hot_tag {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  font-size: 14px;
  color: #4B3B73;
  background-color: #FFFFFF;
  border: 1px solid #E5E7EB;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    border-color: #8A3FFC;
    color: #8A3FFC;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(138, 63, 252, 0.15);
  }

  &.hot_top {
    background: linear-gradient(135deg, #FFF5F5 0%, #FFF0F0 100%);
    border-color: #FFCDCD;

    .hot_num {
      background: linear-gradient(135deg, #FF6B6B 0%, #FF8E8E 100%);
      color: #fff;
    }
  }
}

.hot_num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  font-size: 11px;
  font-weight: 600;
  color: #9B8DC7;
  background: #F0F0F0;
  border-radius: 4px;
}

// 搜索历史区域居中
.history_section {
  width: 640px;
  max-width: 100%;
  z-index: 1;

  .section_header {
    color: #fff;
  }
}

// 区块头部
.section_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

// 区块标题
.section_title {
  font-size: 15px;
  font-weight: 600;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  gap: 8px;

  &::before {
    content: '';
    width: 4px;
    height: 16px;
    background: linear-gradient(180deg, #8A3FFC 0%, #A855F7 100%);
    border-radius: 2px;
  }
}

// 清空历史按钮
clear_history {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  transition: color 0.3s ease;

  &:hover {
    color: #8A3FFC;
  }
}

// 历史标签列表
.history_list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

// 历史标签
.history_tag {
  padding: 8px 16px;
  font-size: 13px;
  color: #4B3B73;
  background-color: #FFFFFF;
  border: 1px solid #E5E7EB;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    border-color: #8A3FFC;
    color: #8A3FFC;
  }
}

// 榜单列表
.rank_list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

// 榜单项
.rank_item {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  padding: 6px 0;
  transition: all 0.3s ease;

  &:hover {
    .rank_text {
      color: #8A3FFC;
    }
  }
}

// 榜单排名
.rank_num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  font-size: 12px;
  font-weight: 600;
  color: #9B8DC7;
  background-color: #F0F0F0;
  border-radius: 4px;

  &.top {
    color: #FFFFFF;
    background: linear-gradient(135deg, #FF6B6B 0%, #FF8E8E 100%);
  }
}

// 榜单文字
.rank_text {
  font-size: 14px;
  color: #4B3B73;
  transition: color 0.3s ease;
}

// 搜索结果区域
.search_result {
  min-height: 400px;
}

// 加载状态
.loading_state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 0;
  color: #9B8DC7;

  i {
    font-size: 40px;
    margin-bottom: 16px;
  }

  span {
    font-size: 14px;
  }
}

// 搜索结果内容布局
.result_content {
  display: flex;
  gap: 40px;
}

// 结果左侧
.result_left {
  flex: 1;
}

// 结果统计
.result_stats {
  font-size: 14px;
  color: #fbfbfb;
  margin-bottom: 24px;

  .highlight {
    color: #FF6B6B;

    &.count {
      font-weight: 600;
    }
  }
}

// 精选主播
.featured_anchor {
  margin-bottom: 32px;
}

// 块标题
.block_title {
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 16px;
}

// 精选卡片
.featured_card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: #FFFFFF;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 20px rgba(138, 63, 252, 0.1);
  }
}

// 精选头像
.featured_avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #ECE6FF;
}

// 精选信息
.featured_info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

// 精选名称
.featured_name {
  font-size: 18px;
  font-weight: 600;
  color: #8A3FFC;
}

// 精选元信息
.featured_meta {
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 13px;
  color: #9B8DC7;
}

// 直播状态
.live_status {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #FF6B6B;
  font-weight: 500;
}

// 直播红点
.live_dot {
  width: 8px;
  height: 8px;
  background-color: #FF6B6B;
  border-radius: 50%;
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

// 元信息项
.meta_item {
  color: #9B8DC7;
}

// 块头部
.block_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

// 主播列表
.anchor_list {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

// 主播项
.anchor_item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    .item_name {
      color: #8A3FFC;
    }
  }
}

// 项头像容器
.item_avatar_wrap {
  position: relative;
  width: 80px;
  height: 80px;
  margin-bottom: 8px;
}

// 项头像
.item_avatar {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #ECE6FF;
}

// 项直播标签
.item_live_tag {
  position: absolute;
  bottom: -4px;
  left: 50%;
  transform: translateX(-50%);
  padding: 2px 8px;
  font-size: 11px;
  color: #FFFFFF;
  background: linear-gradient(135deg, #FF6B6B 0%, #FF8E8E 100%);
  border-radius: 10px;
  white-space: nowrap;
}

// 项名称
.item_name {
  font-size: 14px;
  color: #8A3FFC;
  margin-bottom: 4px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

// 项粉丝数
.item_fans {
  font-size: 12px;
  color: #9B8DC7;
}

// 空状态
.empty_state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px 0;
}

// 空状态图标容器
.empty_icon_wrap {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #ECE6FF 0%, #F9F7FF 100%);
  border-radius: 50%;
  margin-bottom: 20px;

  i {
    font-size: 36px;
    color: #8A3FFC;
  }
}

// 空状态文字
.empty_text {
  font-size: 18px;
  font-weight: 500;
  color: #f3eeff;
  margin-bottom: 8px;
}

// 空状态提示
.empty_tip {
  font-size: 15px;
  color: #fffeff;
}

// 响应式适配
@media (max-width: 900px) {
  .default_content,
  .result_content {
    flex-direction: column;
  }

  .right_section,
  .result_right {
    width: 100%;
  }
}
</style>
